import { render, staticRenderFns } from "./VeicoloFilter.vue?vue&type=template&id=a0bcce04&"
import script from "./VeicoloFilter.vue?vue&type=script&lang=ts&"
export * from "./VeicoloFilter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports